// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"paywall-modal_wrapper__32lg8","header_text":"paywall-modal_header_text__k5ubT","skip_button_wrapper":"paywall-modal_skip_button_wrapper__FOyFz"};